/* eslint-disable import/no-cycle */

import {
  acceptCvTypes,
  acceptImageTypes,
  cvExtensions,
  fileExtensions,
  imagesExtensions,
  maxFileSize as maxFileSizeDefault,
} from 'shared/constants';
import { stringifyError } from 'shared/functions/errors';

import { requestBackend } from 'utils/request';

type FileValidateOptionsType = {
  maxFileSize?: number;
  acceptTypes?: string[];
};

export function onDropFile(
  files: File[],
  {
    acceptTypes = [...acceptImageTypes, ...acceptCvTypes],
    maxFileSize = maxFileSizeDefault,
  }: FileValidateOptionsType = {},
) {
  if (!files.length) {
    return;
  }

  const file = files[0];

  const resultValidate = validateFile(file, {
    maxFileSize,
    acceptTypes,
  });

  if (resultValidate) {
    return alert(resultValidate);
  }

  this.setState({
    file,
    progress: 0,
  });

  requestBackend('/files/url', {
    method: 'POST',
    body: JSON.stringify({ fileName: file.name }),
  }).then((res: { url: string }) => {
    this.setState({ fileUrl: res.url.substr(0, res.url.indexOf('?')) });
    this.xhr.open('put', res.url, true);
    this.xhr.setRequestHeader('Content-Type', 'multipart/form-data');
    this.xhr.send(file);
  });
}

export async function downloadFile(res, filename: string) {
  if (this.unmounted) {
    return;
  }

  if (!this.anchorRef) {
    throw new Error('Anchor ref should be present!');
  }

  if (res.status !== 200) {
    return this.setState({
      error: stringifyError({
        payload: await res.json(),
      }),
      downloading: false,
    });
  }

  const blob = await res.blob();
  const url = window.URL.createObjectURL(blob);

  this.anchorRef.href = url;
  this.anchorRef.download = filename;
  this.anchorRef.click();

  window.URL.revokeObjectURL(url);
}

export const getFileExtension = (filename: string) => {
  const extensionExec = /\.\w{3,4}($|\?)/.exec(filename);
  if (extensionExec) {
    const extension = extensionExec[0].toLowerCase().replace('?', '');
    if (extension === '.pdf') {
      return fileExtensions.pdf;
    } else if (extension === '.txt') {
      return fileExtensions.txt;
    } else if (imagesExtensions.test(extension)) {
      return fileExtensions.image;
    } else if (cvExtensions.test(extension)) {
      return fileExtensions.document;
    }
  }
};

export const validateFile = (
  file: File,
  {
    acceptTypes = [...acceptImageTypes, ...acceptCvTypes],
    maxFileSize = maxFileSizeDefault,
  }: FileValidateOptionsType = {},
) => {
  const maxFileSizeToMb = Math.trunc(maxFileSize / (1024 * 1024));

  if (file.size > maxFileSize) {
    return translate('File size is too large {{maxFileSizeToMb}} Mb max', {
      maxFileSizeToMb,
    });
  }

  if (!acceptTypes.includes(file.type)) {
    return translate('Invalid file type: {{fileType}}', {
      fileType: file.type,
    });
  }

  return null;
};
